



const LoopEstudiantes = [
    {
        "nombres_completos": "Fernando Parra Solis",
        "desc_grado": "1er grado",
        "id_alumno": 865,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 520,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 519,
                "nivel_logro_anual": "1.75000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 512,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Fernando Parra Solis",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 865,
                "id_area_adm": 510,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Armando Galez Pino",
        "desc_grado": "1er grado",
        "id_alumno": 868,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 521,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 520,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 519,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 514,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 513,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 512,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Armando Galez Pino",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 868,
                "id_area_adm": 510,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Andres Giuseppe Rojas",
        "desc_grado": "1er grado",
        "id_alumno": 871,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 521,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 519,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 514,
                "nivel_logro_anual": "3.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 513,
                "nivel_logro_anual": "3.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Andres Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 871,
                "id_area_adm": 510,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Jose Giuseppe Rojas",
        "desc_grado": "1er grado",
        "id_alumno": 872,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 521,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 520,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 519,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 514,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 513,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 512,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Jose Giuseppe Rojas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 872,
                "id_area_adm": 510,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Angela del valle solano",
        "desc_grado": "1er grado",
        "id_alumno": 873,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 520,
                "nivel_logro_anual": "1.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Angela del valle solano",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 873,
                "id_area_adm": 510,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Gerardo Gallo Velez",
        "desc_grado": "1er grado",
        "id_alumno": 874,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 4,
        "id_grado_adm": 574,
        "areas_estudiante": [
            {
                "desc_grado": "1er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 521,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 520,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 101,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 519,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 514,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 513,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 512,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Gerardo Gallo Velez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 4,
                "id_grado_adm": 574,
                "id_alumno": 874,
                "id_area_adm": 510,
                "nivel_logro_anual": null,
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Maria Fonseca Pallares",
        "desc_grado": "2do grado",
        "id_alumno": 875,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 5,
        "id_grado_adm": 573,
        "areas_estudiante": [
            {
                "desc_grado": "2do grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 521,
                "nivel_logro_anual": "1.25000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Matemática",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 520,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Inglés",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 519,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1.3333333333333333
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 514,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 513,
                "nivel_logro_anual": "1.25000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 512,
                "nivel_logro_anual": "1.25000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Maria Fonseca Pallares",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 875,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Ana Rodríguez Rodríguez",
        "desc_grado": "2do grado",
        "id_alumno": 876,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 5,
        "id_grado_adm": 573,
        "areas_estudiante": [
            {
                "desc_grado": "2do grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 521,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Matemática",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 520,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Inglés",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 514,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 513,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Ana Rodríguez Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 876,
                "id_area_adm": 510,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Beatriz Gómez Gómez",
        "desc_grado": "2do grado",
        "id_alumno": 877,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 5,
        "id_grado_adm": 573,
        "areas_estudiante": [
            {
                "desc_grado": "2do grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Matemática",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Inglés",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 514,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Beatriz Gómez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 5,
                "id_grado_adm": 573,
                "id_alumno": 877,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Fernanda Sánchez Sánchez",
        "desc_grado": "3er grado",
        "id_alumno": 881,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 6,
        "id_grado_adm": 575,
        "areas_estudiante": [
            {
                "desc_grado": "3er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 521,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 520,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 519,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 514,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 513,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 512,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Fernanda Sánchez Sánchez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 881,
                "id_area_adm": 510,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Gabriela Pérez Pérez",
        "desc_grado": "3er grado",
        "id_alumno": 882,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 6,
        "id_grado_adm": 575,
        "areas_estudiante": [
            {
                "desc_grado": "3er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 521,
                "nivel_logro_anual": "1.33333333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 520,
                "nivel_logro_anual": "1.33333333333333330000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 1.3333333333333333
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 519,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Gabriela Pérez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 882,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Helena Ramírez Ramírez",
        "desc_grado": "3er grado",
        "id_alumno": 883,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 6,
        "id_grado_adm": 575,
        "areas_estudiante": [
            {
                "desc_grado": "3er grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Matemática",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 520,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Inglés",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "3er grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Helena Ramírez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 6,
                "id_grado_adm": 575,
                "id_alumno": 883,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.75000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Laura Morales Morales",
        "desc_grado": "4to grado",
        "id_alumno": 887,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 7,
        "id_grado_adm": 576,
        "areas_estudiante": [
            {
                "desc_grado": "4to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 521,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 520,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 519,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 514,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Laura Morales Morales",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 887,
                "id_area_adm": 510,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "María Ortiz Ortiz",
        "desc_grado": "4to grado",
        "id_alumno": 888,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 7,
        "id_grado_adm": 576,
        "areas_estudiante": [
            {
                "desc_grado": "4to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 521,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Matemática",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Inglés",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 519,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "María Ortiz Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 888,
                "id_area_adm": 510,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Natalia Jiménez Jiménez",
        "desc_grado": "4to grado",
        "id_alumno": 889,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 7,
        "id_grado_adm": 576,
        "areas_estudiante": [
            {
                "desc_grado": "4to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 520,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 519,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 513,
                "nivel_logro_anual": "1.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 512,
                "nivel_logro_anual": "1.75000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "4to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Natalia Jiménez Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 7,
                "id_grado_adm": 576,
                "id_alumno": 889,
                "id_area_adm": 510,
                "nivel_logro_anual": "2.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Sara Méndez Méndez",
        "desc_grado": "5to grado",
        "id_alumno": 893,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 8,
        "id_grado_adm": 577,
        "areas_estudiante": [
            {
                "desc_grado": "5to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 521,
                "nivel_logro_anual": "3.8333333333333334",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 514,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Sara Méndez Méndez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 893,
                "id_area_adm": 510,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Teresa Romero Romero",
        "desc_grado": "5to grado",
        "id_alumno": 894,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 8,
        "id_grado_adm": 577,
        "areas_estudiante": [
            {
                "desc_grado": "5to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.8333333333333334",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 520,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 514,
                "nivel_logro_anual": "1.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 513,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Teresa Romero Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 894,
                "id_area_adm": 510,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Valeria Herrera Herrera",
        "desc_grado": "5to grado",
        "id_alumno": 895,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 8,
        "id_grado_adm": 577,
        "areas_estudiante": [
            {
                "desc_grado": "5to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 519,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 514,
                "nivel_logro_anual": "1.25000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 513,
                "nivel_logro_anual": "3.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Valeria Herrera Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 8,
                "id_grado_adm": 577,
                "id_alumno": 895,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.8333333333333334",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Rosa Soto Soto",
        "desc_grado": "6to grado",
        "id_alumno": 899,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 9,
        "id_grado_adm": 578,
        "areas_estudiante": [
            {
                "desc_grado": "6to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 519,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Rosa Soto Soto",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 899,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Claudia Aguilar Aguilar",
        "desc_grado": "6to grado",
        "id_alumno": 900,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 9,
        "id_grado_adm": 578,
        "areas_estudiante": [
            {
                "desc_grado": "6to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 521,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 520,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 519,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 514,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 513,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 512,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Claudia Aguilar Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 900,
                "id_area_adm": 510,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Sofía Castro Castro",
        "desc_grado": "6to grado",
        "id_alumno": 901,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 247,
        "id_grado_clickone": 9,
        "id_grado_adm": 578,
        "areas_estudiante": [
            {
                "desc_grado": "6to grado",
                "desc_area": "Personal Social",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 521,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 521,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Matemática",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 520,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 520,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Inglés",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 519,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 519,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Educación Física",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 514,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 514,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Comunicación ",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 513,
                "nivel_logro_anual": "2.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 513,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 512,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 512,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "6to grado",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Sofía Castro Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 5,
                "id_nivel_adm": 247,
                "id_grado_clickone": 9,
                "id_grado_adm": 578,
                "id_alumno": 901,
                "id_area_adm": 510,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 510,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Vanessa Silva Rodríguez",
        "desc_grado": "1er Año",
        "id_alumno": 905,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 10,
        "id_grado_adm": 579,
        "areas_estudiante": [
            {
                "desc_grado": "1er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 536,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 535,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 532,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 530,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 529,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 528,
                "nivel_logro_anual": "3.8333333333333334",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 526,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 525,
                "nivel_logro_anual": "3.2222222222222222",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Vanessa Silva Rodríguez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 905,
                "id_area_adm": 524,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Alejandro Rodríguez Gómez",
        "desc_grado": "1er Año",
        "id_alumno": 906,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 10,
        "id_grado_adm": 579,
        "areas_estudiante": [
            {
                "desc_grado": "1er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 535,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 532,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 530,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 529,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 528,
                "nivel_logro_anual": "3.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 526,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 525,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Alejandro Rodríguez Gómez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 906,
                "id_area_adm": 524,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Benjamín Gómez Fernández",
        "desc_grado": "1er Año",
        "id_alumno": 907,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 10,
        "id_grado_adm": 579,
        "areas_estudiante": [
            {
                "desc_grado": "1er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.8333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 532,
                "nivel_logro_anual": "3.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 530,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 529,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 528,
                "nivel_logro_anual": "2.5833333333333334",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 2.6666666666666665
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 526,
                "nivel_logro_anual": "3.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 525,
                "nivel_logro_anual": "2.16666666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "1er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Benjamín Gómez Fernández",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 10,
                "id_grado_adm": 579,
                "id_alumno": 907,
                "id_area_adm": 524,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Francisco Sánchez Pérez",
        "desc_grado": "2do Año",
        "id_alumno": 911,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 11,
        "id_grado_adm": 580,
        "areas_estudiante": [
            {
                "desc_grado": "2do Año",
                "desc_area": "Matemática",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 536,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Inglés",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 535,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 532,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 530,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 529,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 528,
                "nivel_logro_anual": "3.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 3.6666666666666665
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 526,
                "nivel_logro_anual": "5.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 5.333333333333333
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 525,
                "nivel_logro_anual": "3.9375000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3.875
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Francisco Sánchez Pérez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 911,
                "id_area_adm": 524,
                "nivel_logro_anual": "3.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Guillermo Pérez Ramírez",
        "desc_grado": "2do Año",
        "id_alumno": 912,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 11,
        "id_grado_adm": 580,
        "areas_estudiante": [
            {
                "desc_grado": "2do Año",
                "desc_area": "Matemática",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Inglés",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 532,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 530,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 5
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 529,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 528,
                "nivel_logro_anual": "2.3333333333333333",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 526,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 525,
                "nivel_logro_anual": "2.1875000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2.375
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Guillermo Pérez Ramírez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 912,
                "id_area_adm": 524,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Hugo Ramírez Torres",
        "desc_grado": "2do Año",
        "id_alumno": 913,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 11,
        "id_grado_adm": 580,
        "areas_estudiante": [
            {
                "desc_grado": "2do Año",
                "desc_area": "Matemática",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 536,
                "nivel_logro_anual": "1.33333333333333330000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 1.3333333333333333
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Inglés",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 535,
                "nivel_logro_anual": "1.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 532,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 530,
                "nivel_logro_anual": "1.25000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 529,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 528,
                "nivel_logro_anual": "1.6666666666666667",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1.6666666666666667
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 526,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 525,
                "nivel_logro_anual": "1.12500000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 1.25
                    }
                ]
            },
            {
                "desc_grado": "2do Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Hugo Ramírez Torres",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 11,
                "id_grado_adm": 580,
                "id_alumno": 913,
                "id_area_adm": 524,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Luis Morales Ortiz",
        "desc_grado": "3er Año",
        "id_alumno": 917,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 12,
        "id_grado_adm": 581,
        "areas_estudiante": [
            {
                "desc_grado": "3er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 536,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 535,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 532,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 530,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 529,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 528,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 526,
                "nivel_logro_anual": "3.7500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 525,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Luis Morales Ortiz",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 917,
                "id_area_adm": 524,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Miguel Ortiz Jiménez",
        "desc_grado": "3er Año",
        "id_alumno": 918,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 12,
        "id_grado_adm": 581,
        "areas_estudiante": [
            {
                "desc_grado": "3er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 532,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 530,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 529,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 528,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 526,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 525,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Miguel Ortiz Jiménez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 918,
                "id_area_adm": 524,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Nicolás Jiménez Chávez",
        "desc_grado": "3er Año",
        "id_alumno": 919,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 12,
        "id_grado_adm": 581,
        "areas_estudiante": [
            {
                "desc_grado": "3er Año",
                "desc_area": "Matemática",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Inglés",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 535,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 532,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 530,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 529,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 528,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 526,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 90,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 525,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "3er Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Nicolás Jiménez Chávez",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 12,
                "id_grado_adm": 581,
                "id_alumno": 919,
                "id_area_adm": 524,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Santiago Méndez Romero",
        "desc_grado": "4to Año",
        "id_alumno": 923,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 13,
        "id_grado_adm": 582,
        "areas_estudiante": [
            {
                "desc_grado": "4to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 536,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 535,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 532,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 530,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 529,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 528,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 526,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 525,
                "nivel_logro_anual": "3.7777777777777778",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3.3333333333333335
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Santiago Méndez Romero",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 923,
                "id_area_adm": 524,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Tomás Romero Herrera",
        "desc_grado": "4to Año",
        "id_alumno": 924,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 13,
        "id_grado_adm": 582,
        "areas_estudiante": [
            {
                "desc_grado": "4to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 535,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 532,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 530,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 529,
                "nivel_logro_anual": "3.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 3
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 528,
                "nivel_logro_anual": "5.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 8
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 526,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 525,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 3.5
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Tomás Romero Herrera",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 924,
                "id_area_adm": 524,
                "nivel_logro_anual": "2.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Ulises Herrera Vargas",
        "desc_grado": "4to Año",
        "id_alumno": 925,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 13,
        "id_grado_adm": 582,
        "areas_estudiante": [
            {
                "desc_grado": "4to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 536,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 99,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 98,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 532,
                "nivel_logro_anual": "3.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 106,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 5
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 530,
                "nivel_logro_anual": "1.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 61,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 62,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 529,
                "nivel_logro_anual": "1.5000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": null
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 528,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 66,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 526,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 91,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 525,
                "nivel_logro_anual": "1.11111111111111110000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 104,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 1.3333333333333333
                    }
                ]
            },
            {
                "desc_grado": "4to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Ulises Herrera Vargas",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 13,
                "id_grado_adm": 582,
                "id_alumno": 925,
                "id_area_adm": 524,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Yago Soto Aguilar",
        "desc_grado": "5to Año",
        "id_alumno": 929,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 14,
        "id_grado_adm": 583,
        "areas_estudiante": [
            {
                "desc_grado": "5to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 536,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 532,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 530,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 529,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 528,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 526,
                "nivel_logro_anual": "1.00000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 525,
                "nivel_logro_anual": "1.3750000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 1.5
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 1.25
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Yago Soto Aguilar",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 929,
                "id_area_adm": 524,
                "nivel_logro_anual": "1.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Zeferino Aguilar Castro",
        "desc_grado": "5to Año",
        "id_alumno": 930,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 14,
        "id_grado_adm": 583,
        "areas_estudiante": [
            {
                "desc_grado": "5to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 536,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 535,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 532,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 530,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 529,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 528,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 526,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 525,
                "nivel_logro_anual": "2.2500000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 2.5
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Zeferino Aguilar Castro",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 930,
                "id_area_adm": 524,
                "nivel_logro_anual": "2.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    },
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 2
                    }
                ]
            }
        ]
    },
    {
        "nombres_completos": "Antonio Castro Delgado",
        "desc_grado": "5to Año",
        "id_alumno": 931,
        "id_colegio": 271,
        "id_ano_lectivo": 130,
        "id_nivel_adm": 248,
        "id_grado_clickone": 14,
        "id_grado_adm": 583,
        "areas_estudiante": [
            {
                "desc_grado": "5to Año",
                "desc_area": "Matemática",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 536,
                "nivel_logro_anual": "5.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 100,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 536,
                        "ID_COMPETENCIA": 102,
                        "NIVEL_LOGRO_COMPETENCIA": 6
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Inglés",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 535,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 96,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 535,
                        "ID_COMPETENCIA": 97,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Religiosa ",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 532,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 532,
                        "ID_COMPETENCIA": 107,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Educación Física",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 530,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 530,
                        "ID_COMPETENCIA": 63,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Desarrollo Personal, Ciudadanía y Cívica",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 529,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 60,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 529,
                        "ID_COMPETENCIA": 89,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Comunicación",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 528,
                "nivel_logro_anual": "2.50000000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 67,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 528,
                        "ID_COMPETENCIA": 87,
                        "NIVEL_LOGRO_COMPETENCIA": 1
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencias Sociales",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 526,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 526,
                        "ID_COMPETENCIA": 92,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Ciencia y Tecnología",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 525,
                "nivel_logro_anual": "3.6250000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 103,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 525,
                        "ID_COMPETENCIA": 105,
                        "NIVEL_LOGRO_COMPETENCIA": 3.25
                    }
                ]
            },
            {
                "desc_grado": "5to Año",
                "desc_area": "Arte y Cultura",
                "nombres_completos": "Antonio Castro Delgado",
                "id_colegio": 271,
                "id_ano_lectivo": 130,
                "id_nivel_clickone": 6,
                "id_nivel_adm": 248,
                "id_grado_clickone": 14,
                "id_grado_adm": 583,
                "id_alumno": 931,
                "id_area_adm": 524,
                "nivel_logro_anual": "4.0000000000000000",
                "nivel_logro_competencias_area": [
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 64,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    },
                    {
                        "ID_AREA_ADM": 524,
                        "ID_COMPETENCIA": 65,
                        "NIVEL_LOGRO_COMPETENCIA": 4
                    }
                ]
            }
        ]
    }
]

let condiciones = [
  {
    "id": 24,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 2,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro <strong>\"C\"</strong> en más del <strong>50%</strong> de las competencias de <strong>4</strong> áreas y <strong>\"B\"</strong> en las demás competencias de las mismas áreas  .",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 6,
        "desc_grado": "3er grado"
      },
      {
        "id_grado": 8,
        "desc_grado": "5to grado"
      }
    ],
    "promocion_automatica": null,
    "no_cumple_requerimientos": null,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": 4,
    "ids_calif_literal_nivel_logro": [
      {
        "id": 8,
        "literal": "C",
        "descripcion": "Cuando el estudiante muestra un progreso mínimo en una competencia de acuerdo al nivel esperado. Evidencia con frecuencia dificultades en el desarrollo de las tareas, por lo que necesita mayor tiempo de acompañamiento e intervención del docente",
        "nota_min": 2,
        "nota_max": 10,
        "id_pais": 145,
        "interpretacion": "En inicio",
        "base_calculo": 1
      }
    ],
    "areas_comp_restantes": true,
    "ids_calif_literal_nivel_logro_comp_restantes": [
      {
        "id": 7,
        "literal": "B",
        "descripcion": "Cuando el estudiante está próximo o cerca al nivel esperado respecto a la competencia, para lo cual requiere acompañamiento durante un tiempo razonable para lograrlo",
        "nota_min": 11,
        "nota_max": 13,
        "id_pais": 145,
        "interpretacion": "En proceso",
        "base_calculo": 2.5
      }
    ],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": ">",
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 25,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 3,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro ...  ...  .",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 6,
        "desc_grado": "3er grado"
      },
      {
        "id_grado": 8,
        "desc_grado": "5to grado"
      }
    ],
    "promocion_automatica": null,
    "no_cumple_requerimientos": true,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": null,
    "ids_calif_literal_nivel_logro": null,
    "areas_comp_restantes": false,
    "ids_calif_literal_nivel_logro_comp_restantes": [],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": null,
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 26,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 1,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno realiza promocion automática",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 4,
        "desc_grado": "1er grado"
      }
    ],
    "promocion_automatica": true,
    "no_cumple_requerimientos": null,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": null,
    "ids_calif_literal_nivel_logro": null,
    "areas_comp_restantes": false,
    "ids_calif_literal_nivel_logro_comp_restantes": [],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": null,
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 23,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 1,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro <strong>\"B\"</strong> en el <strong>50%</strong> o más de las competencias de <strong>7</strong> áreas y <strong>\"C o A o AD\"</strong> en las demás competencias de las mismas áreas  .",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 6,
        "desc_grado": "3er grado"
      },
      {
        "id_grado": 8,
        "desc_grado": "5to grado"
      }
    ],
    "promocion_automatica": false,
    "no_cumple_requerimientos": null,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": 7,
    "ids_calif_literal_nivel_logro": [
      {
        "id": 7,
        "literal": "B",
        "descripcion": "Cuando el estudiante está próximo o cerca al nivel esperado respecto a la competencia, para lo cual requiere acompañamiento durante un tiempo razonable para lograrlo",
        "nota_min": 11,
        "nota_max": 13,
        "id_pais": 145,
        "interpretacion": "En proceso",
        "base_calculo": 2.5
      }
    ],
    "areas_comp_restantes": true,
    "ids_calif_literal_nivel_logro_comp_restantes": [
      {
        "id": 8,
        "literal": "C",
        "descripcion": "Cuando el estudiante muestra un progreso mínimo en una competencia de acuerdo al nivel esperado. Evidencia con frecuencia dificultades en el desarrollo de las tareas, por lo que necesita mayor tiempo de acompañamiento e intervención del docente",
        "nota_min": 2,
        "nota_max": 10,
        "id_pais": 145,
        "interpretacion": "En inicio",
        "base_calculo": 1
      },
      {
        "id": 6,
        "literal": "A",
        "descripcion": "Cuando el estudiante evidencia el nivel esperado respecto a la competencia, demostrando manejo satisfactorio en todas las tareas propuestas y en el tiempo programado",
        "nota_min": 14,
        "nota_max": 17,
        "id_pais": 145,
        "interpretacion": "Logro previsto",
        "base_calculo": 3
      },
      {
        "id": 5,
        "literal": "AD",
        "descripcion": "Cuando el estudiante evidencia un nivel superior a lo esperado respecto a la competencia. Esto quiere decir que demuestra aprendizajes que van más allá del nivel esperado ",
        "nota_min": 18,
        "nota_max": 20,
        "id_pais": 145,
        "interpretacion": "Logro destacado",
        "base_calculo": 4
      }
    ],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": ">=",
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 27,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 1,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro <strong>\"AD o A\"</strong> en el <strong>50%</strong> o más de las competencias de <strong>4</strong> áreas , <strong>\"B\"</strong> en las demás competencias de las mismas áreas  y <strong>\"B\"</strong> en todas las competencias las de <strong>3</strong> áreas restantes",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 5,
        "desc_grado": "2do grado"
      },
      {
        "id_grado": 7,
        "desc_grado": "4to grado"
      },
      {
        "id_grado": 9,
        "desc_grado": "6to grado"
      }
    ],
    "promocion_automatica": false,
    "no_cumple_requerimientos": null,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": 4,
    "ids_calif_literal_nivel_logro": [
      {
        "id": 5,
        "literal": "AD",
        "descripcion": "Cuando el estudiante evidencia un nivel superior a lo esperado respecto a la competencia. Esto quiere decir que demuestra aprendizajes que van más allá del nivel esperado ",
        "nota_min": 18,
        "nota_max": 20,
        "id_pais": 145,
        "interpretacion": "Logro destacado",
        "base_calculo": 4
      },
      {
        "id": 6,
        "literal": "A",
        "descripcion": "Cuando el estudiante evidencia el nivel esperado respecto a la competencia, demostrando manejo satisfactorio en todas las tareas propuestas y en el tiempo programado",
        "nota_min": 14,
        "nota_max": 17,
        "id_pais": 145,
        "interpretacion": "Logro previsto",
        "base_calculo": 3
      }
    ],
    "areas_comp_restantes": true,
    "ids_calif_literal_nivel_logro_comp_restantes": [
      {
        "id": 7,
        "literal": "B",
        "descripcion": "Cuando el estudiante está próximo o cerca al nivel esperado respecto a la competencia, para lo cual requiere acompañamiento durante un tiempo razonable para lograrlo",
        "nota_min": 11,
        "nota_max": 13,
        "id_pais": 145,
        "interpretacion": "En proceso",
        "base_calculo": 2.5
      }
    ],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": ">=",
    "areas_restantes_condiciones": true,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": 3,
    "ids_calif_literal_nivel_logro_areas_restantes": [
      {
        "id": 7,
        "literal": "B",
        "descripcion": "Cuando el estudiante está próximo o cerca al nivel esperado respecto a la competencia, para lo cual requiere acompañamiento durante un tiempo razonable para lograrlo",
        "nota_min": 11,
        "nota_max": 13,
        "id_pais": 145,
        "interpretacion": "En proceso",
        "base_calculo": 2.5
      }
    ],
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 28,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 2,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro <strong>\"C\"</strong> en más del <strong>50%</strong> de las competencias de <strong>4</strong> áreas y <strong>\"B\"</strong> en las demás competencias de las mismas áreas  .",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 5,
        "desc_grado": "2do grado"
      },
      {
        "id_grado": 7,
        "desc_grado": "4to grado"
      },
      {
        "id_grado": 9,
        "desc_grado": "6to grado"
      }
    ],
    "promocion_automatica": null,
    "no_cumple_requerimientos": null,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": 4,
    "ids_calif_literal_nivel_logro": [
      {
        "id": 8,
        "literal": "C",
        "descripcion": "Cuando el estudiante muestra un progreso mínimo en una competencia de acuerdo al nivel esperado. Evidencia con frecuencia dificultades en el desarrollo de las tareas, por lo que necesita mayor tiempo de acompañamiento e intervención del docente",
        "nota_min": 2,
        "nota_max": 10,
        "id_pais": 145,
        "interpretacion": "En inicio",
        "base_calculo": 1
      }
    ],
    "areas_comp_restantes": true,
    "ids_calif_literal_nivel_logro_comp_restantes": [
      {
        "id": 7,
        "literal": "B",
        "descripcion": "Cuando el estudiante está próximo o cerca al nivel esperado respecto a la competencia, para lo cual requiere acompañamiento durante un tiempo razonable para lograrlo",
        "nota_min": 11,
        "nota_max": 13,
        "id_pais": 145,
        "interpretacion": "En proceso",
        "base_calculo": 2.5
      }
    ],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": ">",
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  },
  {
    "id": 29,
    "id_normativa_ministerial": 2,
    "id_tipos_promocion": 3,
    "descripcion_condicion": "<strong>Enunciado</strong>: El alumno alcanza el nivel de logro ...  ...  .",
    "id_nivel_ck1": 5,
    "id_grado_ck1": [
      {
        "id_grado": 5,
        "desc_grado": "2do grado"
      },
      {
        "id_grado": 7,
        "desc_grado": "4to grado"
      },
      {
        "id_grado": 9,
        "desc_grado": "6to grado"
      }
    ],
    "promocion_automatica": null,
    "no_cumple_requerimientos": true,
    "areas_aleatoria": true,
    "id_area_ck1": null,
    "cantidad_de_areas": null,
    "ids_calif_literal_nivel_logro": null,
    "areas_comp_restantes": false,
    "ids_calif_literal_nivel_logro_comp_restantes": [],
    "porcentaje_competencias": 50,
    "porcentaje_competencias_condicion": null,
    "areas_restantes_condiciones": false,
    "id_area_ck1_restantes": null,
    "cantidad_areas_restantes": null,
    "ids_calif_literal_nivel_logro_areas_restantes": null,
    "porcentaje_competencias_areas_restantes": 100,
    "porcentaje_competencias_areas_restantes_condicion": "=",
    "areas_permitidas": [
      {
        "id": 123,
        "id_colegio": 0,
        "desc_area": "Arte y Cultura",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:27.257Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:32.333Z",
        "estado": 1,
        "icono_area": "fa-paint-brush",
        "color_area": "#FADC4E",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 120,
        "id_colegio": 0,
        "desc_area": "Ciencia y Tecnología",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:54:46.198Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-06-05T20:56:51.326Z",
        "estado": 1,
        "icono_area": "fa-vial",
        "color_area": "#D43243",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 119,
        "id_colegio": 0,
        "desc_area": "Comunicación ",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:47:07.611Z",
        "id_us_mod": null,
        "fec_us_mod": "2021-02-19T18:49:27.620Z",
        "estado": 1,
        "icono_area": "fa-edit",
        "color_area": "#FD0505",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 122,
        "id_colegio": 0,
        "desc_area": "Educación Física",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:56:03.185Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-27T13:30:47.545Z",
        "estado": 1,
        "icono_area": "fa-futbol",
        "color_area": "#4CAFF7",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 127,
        "id_colegio": 0,
        "desc_area": "Inglés",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:59:21.743Z",
        "id_us_mod": null,
        "fec_us_mod": "2022-10-19T16:10:26.786Z",
        "estado": 1,
        "icono_area": "fa-book-reader",
        "color_area": "#E852CD",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 121,
        "id_colegio": 0,
        "desc_area": "Matemática",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:55:32.415Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-10-11T19:31:03.933Z",
        "estado": 1,
        "icono_area": "fa-square-root-alt",
        "color_area": "#1B4C7D",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      },
      {
        "id": 124,
        "id_colegio": 0,
        "desc_area": "Personal Social",
        "id_us_ing": 17,
        "fec_us_ing": "2021-02-19T18:57:33.546Z",
        "id_us_mod": null,
        "fec_us_mod": "2023-07-27T22:59:45.257Z",
        "estado": 1,
        "icono_area": "fa-handshake",
        "color_area": "#5BBA4B",
        "id_nivel": 5,
        "id_pais": 145,
        "ck1": true,
        "parent_id": null,
        "nombre_pais": "PERÚ",
        "desc_nivel": "Primaria",
        "color_nivel": "#79CA65"
      }
    ]
  }
]

function actualizarContadoresYEstado(datosArea, criterio_area_condicion, criterio_area_condicion_restante, criterio_estado_final_area) {
    // Actualizar contadores basados en criterio_area_condicion
    if (criterio_area_condicion === "PROMOVIDO") {
      datosArea.promovidos++;
    } else if (criterio_area_condicion === "PERMANENCIA") {
      datosArea.permanencia++;
    }
  
    // Actualizar contadores basados en criterio_area_condicion_restante
    if (criterio_area_condicion_restante === "PROMOVIDO RESTANTE") {
      datosArea.promovidosRestantes++;
    } else if (criterio_area_condicion_restante === "PERMANENCIA RESTANTE") {
      datosArea.permanenciaRestantes++;
    }
  
    // Actualizar criterio_estado_final
    if (criterio_estado_final_area === "PROMOVIDO" || criterio_estado_final_area === "PERMANENCIA") {
      return criterio_estado_final_area;
    }
    
    return "RECUPERACIÓN PEDAGÓGICA"; // Default if none of the conditions are met
  }

function cierreFinalSituacionEstudiante() {

    try {

        let datosEstudiantesGrados = LoopEstudiantes.filter(alumno => {
            return condiciones.some(condicion => 
                condicion.id_grado_ck1.some(grado => grado.id_grado === alumno.id_grado_clickone)
            );
        });

        const estudiantesCriterioFilter = datosEstudiantesGrados.map(alumno => {

            let criterio_estado_final = 'NO DEFINIDO';
            const totalAreasCompetencias = alumno.areas_estudiante.length;
            const datosArea = { promovidos: 0, promovidosRestantes: 0, permanencia: 0, permanenciaRestantes: 0, recuperacion: 0, recuperacionRestantes: 0, totalAreasCompetencias }

            const areas_estudiante = alumno.areas_estudiante.map((areas_alumno) => {

                const { criterio_area_condicion, criterio_area_condicion_restante, criterio_estado_final_area } = filtradoCondicion(condiciones, areas_alumno, datosArea);
                criterio_estado_final = actualizarContadoresYEstado(datosArea, criterio_area_condicion, criterio_area_condicion_restante, criterio_estado_final_area);
            
                return { ...areas_alumno, criterio_area_condicion };
            
            });

            return { ...alumno, areas_estudiante, criterio_estado_final };

        });

        // console.log('esto vamos a filtrar', estudiantesCriterioFilter);

        // FILTRAMOS PROMOVIDOS:
        const soloPromovidos = estudiantesCriterioFilter.filter(it => it.criterio_estado_final === "PROMOVIDO");

        // console.log({soloPromovidos});
        return { DATOS: estudiantesCriterioFilter, MSG: true };

    } catch (error) {
        console.log(error);
    }
}

function filtradoCondicion(condiciones, areas_alumno, datosArea) {

    // eslint-disable-next-line no-unused-vars
    let { promovidos, promovidosRestantes, permanencia, permanenciaRestantes, recuperacion, recuperacionRestantes, totalAreasCompetencias } = datosArea;

    let criterio_area_condicion = 'NO DEFINIDO';
    let criterio_area_condicion_restante = 'NO DEFINIDO';
    let criterio_estado_final_area = 'NO DEFINIDO';
    let areasRest = 0;

    condiciones.map((condicion) => {

        const condicionAreasAleatorias = condicion.areas_aleatoria;
        const condicionAreasAleatoriasRestantes = condicion.areas_comp_restantes;
        const condicionAreasRestantes = condicion.areas_restantes_condiciones;
        
        const datosArrayCalifLiteral = condicion.ids_calif_literal_nivel_logro;       
        let nivelLogroBase = [];
        if (Array.isArray(datosArrayCalifLiteral)) {
            nivelLogroBase = datosArrayCalifLiteral.map(el => el.base_calculo == 2.5 ? 2 : el.base_calculo);
        }

        const datosArrayCalifLiteralCompRest = condicion.ids_calif_literal_nivel_logro_comp_restantes;
        let nivelLogroCompRest = [];
        if (Array.isArray(datosArrayCalifLiteralCompRest)) {
            nivelLogroCompRest = datosArrayCalifLiteralCompRest.map(el => el.base_calculo == 2.5 ? 2 : el.base_calculo);
        }

        const datosArrayCalifLiteral_restantes = condicion.ids_calif_literal_nivel_logro_areas_restantes;
        let nivelLogroBaseAreas_restantes = [];
        if (Array.isArray(datosArrayCalifLiteral_restantes)) {
            nivelLogroBaseAreas_restantes = datosArrayCalifLiteral_restantes.map(el => el.base_calculo == 2.5 ? 2 : el.base_calculo);
        }
        const PorcentajeCom = condicion.porcentaje_competencias;
        const cantidadAreas = condicion.cantidad_de_areas;
        const operador = condicion.porcentaje_competencias_condicion;
        const porcentajeComAreasRestantes = condicion.porcentaje_competencias_areas_restantes;
        const cantidadAreas_restantes = condicion.cantidad_areas_restantes;
        const operador_restantes = condicion.porcentaje_competencias_areas_restantes_condicion;
        const compentencias = areas_alumno.nivel_logro_competencias_area;
        // const id_alumno = areas_alumno.id_alumno;
        const ArrayGradosCondicion = condicion.id_grado_ck1;
        const idGradosCondicion = areas_alumno.id_grado_clickone;
   
        if (ArrayGradosCondicion.some(item => item.id_grado === idGradosCondicion)) {
            if (condicion.promocion_automatica) {

                criterio_area_condicion = 'PROMOVIDO';
                criterio_estado_final_area = 'PROMOVIDO';

            } else {
                switch (condicion.id_tipos_promocion) {

                    case 1: { 
                        let { resultadosPromocionArea, resultadosPromocionAreaRestantes } = criterioPromocion(
                            compentencias,
                            condicionAreasAleatorias,
                            nivelLogroBase,
                            PorcentajeCom,
                            operador,
                            condicionAreasAleatoriasRestantes,
                            nivelLogroCompRest,
                            condicionAreasRestantes,
                            nivelLogroBaseAreas_restantes,
                            porcentajeComAreasRestantes,
                            operador_restantes);

                        if (resultadosPromocionArea) {
                            if (criterio_area_condicion == 'NO DEFINIDO') {
                                criterio_area_condicion = 'PROMOVIDO';
                                promovidos++;
                            }
                        } else {
                            if (resultadosPromocionAreaRestantes) {
                                criterio_area_condicion_restante = 'PROMOVIDO RESTANTE';
                                promovidosRestantes++;
                            }
                        }

                        if (promovidos >= cantidadAreas) {
                            areasRest = totalAreasCompetencias - promovidos;
                            if (condicionAreasAleatorias && !condicionAreasAleatoriasRestantes && !condicionAreasRestantes) {
                                criterio_estado_final_area = 'PROMOVIDO';
                            } else if (condicionAreasAleatorias && condicionAreasAleatoriasRestantes && !condicionAreasRestantes) {
                                criterio_estado_final_area = 'PROMOVIDO';
                            } else if (condicionAreasAleatorias && condicionAreasAleatoriasRestantes && condicionAreasRestantes) {
                                if (areasRest <= cantidadAreas_restantes) {
                                    criterio_estado_final_area = promovidosRestantes >= areasRest && promovidosRestantes <= cantidadAreas_restantes && promovidos >= cantidadAreas ? 'PROMOVIDO' : criterio_estado_final_area;
                                }
                            }
                        }

                        break;
                    }
                    case 2: { 
                        let { resultadosPermanenciaArea, resultadosPermanenciaAreaRestantes } = criterioPermanencia(
                            compentencias,
                            condicionAreasAleatorias,
                            nivelLogroBase,
                            PorcentajeCom,
                            operador,
                            condicionAreasAleatoriasRestantes,
                            nivelLogroCompRest,
                            condicionAreasRestantes,
                            nivelLogroBaseAreas_restantes,
                            porcentajeComAreasRestantes,
                            operador_restantes);

                        if (resultadosPermanenciaArea) {
                            permanencia++;
                            if (criterio_area_condicion == 'NO DEFINIDO') {
                                criterio_area_condicion = 'PERMANENCIA';
                            }
                        } else {
                            if (resultadosPermanenciaAreaRestantes) {
                                permanenciaRestantes++;
                            }
                        }

                        if (permanencia >= cantidadAreas) {
                            areasRest = totalAreasCompetencias - permanencia;
                            if (condicionAreasAleatorias && !condicionAreasAleatoriasRestantes && !condicionAreasRestantes) {
                                criterio_estado_final_area = 'PERMANENCIA';
                            } else if (condicionAreasAleatorias && condicionAreasAleatoriasRestantes && !condicionAreasRestantes) {
                                criterio_estado_final_area = 'PERMANENCIA';
                            } else if (condicionAreasAleatorias && condicionAreasAleatoriasRestantes && condicionAreasRestantes) {
                                if (areasRest <= cantidadAreas_restantes) {
                                    criterio_estado_final_area = permanenciaRestantes >= areasRest && permanenciaRestantes <= cantidadAreas_restantes && permanencia >= cantidadAreas ? 'PERMANENCIA' : criterio_estado_final_area;
                                }
                            }
                        }
                        break;
                    }
                    default:
                        break;
                }
            }   
        }
    });

    criterio_area_condicion = (criterio_area_condicion != "PROMOVIDO" && criterio_area_condicion != "PERMANENCIA") ? "RECUPERACIÓN PEDAGÓGICA" : criterio_area_condicion;
    criterio_estado_final_area = (criterio_estado_final_area != "PROMOVIDO" && criterio_estado_final_area != "PERMANENCIA") ? "RECUPERACIÓN PEDAGÓGICA" : criterio_estado_final_area;
    return { criterio_area_condicion, criterio_area_condicion_restante, criterio_estado_final_area }

}

function criterioPromocion(notas_competencias, condicionAreasAleatorias, nivelLogroBase, porcentaje_base, operador, condicionAreasAleatoriasRestantes, nivelLogroCompRest, condicionAreasRestantes, nivelLogroBaseAreas_restantes, porcentajeComAreasRestantes, operador_restantes){
    
    let resultadosPromocionArea = false;
    let resultadosPromocionAreaRestantes = false;
    let conteoTotalcompetencias = notas_competencias.length;  
    let conteoCompetenciasValidas = notas_competencias.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBase) <= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length;
    let totalresto = conteoTotalcompetencias - conteoCompetenciasValidas;  
    let competenciasRestantes = notas_competencias.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBase) > Math.round(ol.NIVEL_LOGRO_COMPETENCIA));
    let conteoCompetenciasRestantes = competenciasRestantes.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroCompRest) <= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length; 
  
    operador = conteoTotalcompetencias == 1 ? '=' : operador;
    let porcentajeCoinciden = (conteoCompetenciasValidas == 0) ? false : comparar((conteoCompetenciasValidas), operador, Math.round(conteoTotalcompetencias*(porcentaje_base/100)));
    let porcentajeCoincidenRestantes = conteoCompetenciasRestantes == totalresto;
  
    if((porcentajeCoinciden && porcentajeCoincidenRestantes && condicionAreasAleatorias && condicionAreasAleatoriasRestantes)||
    (porcentajeCoinciden && condicionAreasAleatorias && !condicionAreasAleatoriasRestantes)){ //Cumple con la condicion por lo tanto esta en promocion
      resultadosPromocionArea = true;  
  
    }else{
  
      if (condicionAreasRestantes) {
        let conteoCompetenciasValidasAreasRestantes = notas_competencias.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBaseAreas_restantes) <= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length;
        operador_restantes = conteoTotalcompetencias == 1 ? '=' : operador_restantes;
        let porcentajeCoincidenAreasRestantes = (conteoCompetenciasValidasAreasRestantes == 0) ? false : comparar(conteoCompetenciasValidasAreasRestantes, operador_restantes, Math.round(conteoTotalcompetencias*(porcentajeComAreasRestantes/100)));
        if(porcentajeCoincidenAreasRestantes) {
          resultadosPromocionAreaRestantes = true;
        }
      }
    } 
  
    return { resultadosPromocionArea, resultadosPromocionAreaRestantes };
  }
  
  function criterioPermanencia(notas_competencias, condicionAreasAleatorias, nivelLogroBase, porcentaje_base, operador, condicionAreasAleatoriasRestantes, nivelLogroCompRest, condicionAreasRestantes, nivelLogroBaseAreas_restantes, porcentajeComAreasRestantes, operador_restantes){
  
    let resultadosPermanenciaArea = false;  
    let resultadosPermanenciaAreaRestantes = false;
    let conteoTotalcompetencias = notas_competencias.length;  
    let conteoCompetenciasValidas = notas_competencias.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBase) >= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length;
    let totalresto = conteoTotalcompetencias - conteoCompetenciasValidas;
    let competenciasRestantes = notas_competencias.filter(ol => !(ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBase) >= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)));
    let conteoCompetenciasRestantes = competenciasRestantes.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroCompRest) >= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length;
  
    operador = conteoTotalcompetencias == 1 ? '=' : operador;
    let porcentajeCoinciden = (conteoCompetenciasValidas == 0) ? false : comparar(conteoCompetenciasValidas, operador, Math.round(conteoTotalcompetencias*(porcentaje_base/100)));
    let porcentajeCoincidenRestantes = conteoCompetenciasRestantes == totalresto;
   
    if (porcentajeCoinciden && porcentajeCoincidenRestantes){ 
      resultadosPermanenciaArea = true;
    }else{
      if (condicionAreasRestantes) {
        let conteoCompetenciasValidasAreasRestantes = notas_competencias.filter(ol => ol.NIVEL_LOGRO_COMPETENCIA && Math.min(...nivelLogroBaseAreas_restantes) >= Math.round(ol.NIVEL_LOGRO_COMPETENCIA)).length;
        operador_restantes = conteoTotalcompetencias == 1 ? '=' : operador_restantes;
        let porcentajeCoincidenAreasRestantes = (conteoCompetenciasValidasAreasRestantes == 0) ? false : comparar(conteoCompetenciasValidasAreasRestantes, operador_restantes, Math.round(conteoTotalcompetencias*(porcentajeComAreasRestantes/100)));
        if(porcentajeCoincidenAreasRestantes) {
          resultadosPermanenciaAreaRestantes = true;
        }        
      }
    }  
    return { resultadosPermanenciaArea, resultadosPermanenciaAreaRestantes };
  }
  
  function comparar(valor, operador, comparacion) {
    switch (operador) {
      case '=':
      case '==':
        return valor == comparacion;
      case '===':
        return valor === comparacion;
      case '<':
        return valor < comparacion;
      case '>':
        return valor > comparacion;
      case '<=':
        return valor <= comparacion;
      case '>=':
        return valor >= comparacion;
      default:
        return false;   
      }
  }

const respuesta = cierreFinalSituacionEstudiante();

export default {data:respuesta};